<template>
    <el-input
        v-if="showInput"
        class="search-input"
        v-model.trim="searchValue"
        :placeholder="placeholder"
        :clearable="false"
        :maxlength="maxLength"
        @keyup.enter="searchFunc"
    >
        <template #suffix>
            <i
                class="iconfont icon-a-yijianshanchu1x clear-icon-wrap"
                v-show="props.isClear && searchValue"
                @click="clearFunc"
            ></i>
            <span class="flex-center" @click="searchFunc()">
                <i class="iconfont icon-a-sousuoda-zhuye"></i>
            </span>
        </template>
    </el-input>
    <div class="search-icon-box" v-else>
        <i class="iconfont icon-a-sousuoda-zhuye" @click="showInput = true"></i>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    placeholder: {
        type: String,
        default: '搜索',
    },
    isClear: {
        type: Boolean,
        default: false,
    },
    maxLength: {
        type: Number,
        default: 100,
    },
});
const emit = defineEmits(['search-input', 'clear-input']);

const showInput = ref(false);
const searchValue = ref('');

function searchFunc() {
    emit('search-input', searchValue.value);
}

function clearFunc() {
    searchValue.value = '';
    emit('clear-input');
}
</script>

<style scoped lang="scss">
.search-input {
    height: 32px;
    :deep(.el-input__wrapper) {
        box-shadow: 0 0 0 1px var(--srt-input-border-color) inset;
        padding: 1px 6px 1px 11px;
    }
    :deep(.el-input__suffix) {
        cursor: pointer;
    }
    :deep(.el-input__inner) {
        color: var(--srt-color-black);
    }
    .clear-icon-wrap {
        font-size: 14px;
        margin-right: 12px;
        color: #cccccc;
        display: none;
    }
    &:hover {
        .clear-icon-wrap {
            display: block;
        }
    }
}
:deep(input::-webkit-input-placeholder) {
    /* WebKit browsers */
    color: #cccccc;
}

:deep(input:-moz-placeholder) {
    /* Mozilla Firefox 4 to 18 */
    color: #cccccc;
}

:deep(input::-moz-placeholder) {
    /* Mozilla Firefox 19+ */
    color: #cccccc;
}

:deep(input:-ms-input-placeholder) {
    /* Internet Explorer 10+ */
    color: #cccccc;
}
.icon-a-sousuoda-zhuye {
    font-size: 18px;
    color: var(--home-main-color);
    cursor: pointer;
}
.search-icon-box {
    line-height: 32px;
    text-align: right;
    padding-right: 6px;
}
</style>
